const formatTrackSubInfo = (item) => {
  const { editType = '', versionType = '' } = typeof item === 'object' ? item || {} : {};
  return editType && versionType ? `${editType} / ${versionType}` : editType || versionType;
};

export default formatTrackSubInfo;
